import Palettes from './Palettes.container';

export default Palettes;
